import type { BiDataOverrides, TeaserBiActionType } from '@haaretz/s-data-structure-types';

export default function isTeaserBiData(
  data: BiDataOverrides | TeaserBiActionType
): data is TeaserBiActionType {
  if (!data || typeof data !== 'object') return false;

  return (data as TeaserBiActionType).teaser !== undefined;
}
